exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host /deep/  {\r\n\tfont-family: Arial, \"\\5FAE\\8EDF\\6B63\\9ED1\\9AD4\", \"Microsoft JhengHei\", \"\\6A19\\6977\\9AD4\", DFKai-SB, sans-serif;\r\n}\r\n\r\n.navbar-nav {\r\n    margin-top: 12px;\r\n}\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/noomo/Desktop/project/newCefKid/cefapp2/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = main